import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "initials",
    standalone: false
})
export class InitialsPipe implements PipeTransform {
  transform(fullName: string): any {
    if(fullName!=undefined){
      if(fullName.includes("."))
      {
        return fullName == undefined?fullName:fullName
        .split(".")
        .map(n => n[0]==undefined?n[0]:n[0].toUpperCase())
        .join("");
      }
      else
      {
        return fullName == undefined?fullName:fullName
        .split("_")
        .map(n => n[0]==undefined?n[0]:n[0].toUpperCase())
        .join("");
      }
    }
    
    
  }
}